export default __webpack_public_path__ + "static/media/15.30546bb7.png";